import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { fileEndpoints } from '../../services/api/endpoints/file.endpoint';
import { logger } from '../../utils/logger';

export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const uploadFile = async (file: File) => {
    if (!selectedOrganizationId) {
      throw new Error('No organization selected');
    }

    setIsUploading(true);
    setError(null);

    try {
      // Generate presigned URL
      const { url } = await fileEndpoints.generatePresignedUrl({
        clientId: selectedOrganizationId,
        fileName: file.name,
        fileType: file.type,
      });

      // Upload file using presigned URL
      await fileEndpoints.uploadFileWithPresignedUrl(url, file);

      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to upload file';
      setError(message);
      logger.error('Error uploading file:', err);
      throw err;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadFile,
    isUploading,
    error,
    clearError: () => setError(null),
  };
};
